import script from "./JugadoresView.vue?vue&type=script&setup=true&lang=ts"
export * from "./JugadoresView.vue?vue&type=script&setup=true&lang=ts"

import "./JugadoresView.vue?vue&type=style&index=0&id=4e6d8415&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e6d8415"]])

export default __exports__